import { Box, CircularProgress, IconButton, Modal, Stack, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import Loader from "../../common/Loader";
import { SAVE_SITE_DESCRIPTION } from "../../constant/Apipath";
import { BIBlue, BIGrey } from "../../assets/helpers";
import { Postrequestcall } from "../../request/Postrequest";
import { Close as CloseIcon, Info } from "@mui/icons-material";
import { English } from "../../constant/EnglishFallback";

export default function AddDescription(props) {
  const { loginData, selectedSite, multiLanguageData } = useSelector((state) => state?.main);

  const {
    TEXT_NEW_DESCRIPTION = English?.SiteDetail?.TEXT_NEW_DESCRIPTION,
    TEXT_ENTER_DESCRIPTION = English?.SiteDetail?.TEXT_ENTER_DESCRIPTION
  } = multiLanguageData?.SiteDetail || {};

  const [description, setDescription] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const onDescriptionchange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    setDescription(inputValue);
  };

  const onSaveDescription = async () => {
    try {
      if (description !== "") {
        setIsSaving(true);
        const descObj = {
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              Id: 0,
              SiteId: selectedSite?.id,
              Description: description?.trim(),
              ModifiedBy: loginData?.userInformation?.UserId
            }
          ]
        };
        let getResponse = await Postrequestcall(
          SAVE_SITE_DESCRIPTION,
          descObj,
          loginData?.accessToken
        );
        if (getResponse.data.status === true) {
          props.handleClose();
          props.getSiteDescriptions(1);
        } else {
          alert(getResponse?.data?.data[0]?.message);
          props.handleClose();
        }
      }
    } catch (error) {
      console.log("onSaveDescription-> Error While Saving Site Description: ", error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal open={props.addDescriptionDialogOpen} onClose={props.handleClose}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography className="add-title">{TEXT_NEW_DESCRIPTION}</Typography>
          <Stack flexDirection={"row"} gap={1} alignItems={"center"}>
            <CloseIcon
              style={{ color: "#083DB8", cursor: "pointer" }}
              onClick={props.handleClose}
            />
            <IconButton disabled={description === "" || isSaving} onClick={() => onSaveDescription()}>
              {isSaving ? (
                <CircularProgress style={{ color: BIGrey }} size={18} />
              ) : (
                <SaveIcon
                  style={{
                    color: description === "" ? BIGrey : BIBlue,
                    cursor: "pointer"
                  }}
                />
              )}
            </IconButton>
          </Stack>
        </Box>
        <TextField
          label={TEXT_ENTER_DESCRIPTION}
          slotProps={{
            input: {
              multiline: true,
              inputComponent: "textarea"
            }
          }}
          name="description"
          rows={3}
          variant="outlined"
          fullWidth
          value={description}
          onChange={onDescriptionchange}
        />
      </Box>
    </Modal>
  );
}
